import { CHAT_MESSAGE_FAILED_REASONS } from 'cpool-constants';
import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

// Exactly one of messageId (outbound saga) or metaMessageId (Meta webhook WAMID).
export const schemaChatMessageFailedPayload = z
    .object({
        messageId: schemaId.optional(),
        metaMessageId: z.string().min(1).optional(),
        reason: z.nativeEnum(CHAT_MESSAGE_FAILED_REASONS),
        reasonDetail: z.string().min(1),
    })
    .refine((data) => Boolean(data.messageId) !== Boolean(data.metaMessageId), {
        message: 'exactly one of messageId or metaMessageId must be set',
    });

export type Schema_ChatMessageFailedPayload = z.infer<typeof schemaChatMessageFailedPayload>;
